import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Обновление
  update (id, data, statusId) {
    return axios.post(`${i18n.locale}/api/animalAccounting/update/${id}?status=${statusId}`, data)
  },
  // Получение данных для формы
  getFormData (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/formData/${id}`)
  },
  // Список оопт по текущему СОАТЕ
  listOoptBySoate (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/ooptListBySoate/${id}`)
  },
  // Список участков и наблюдателей по текущему ООПТ
  listObservePlotAndOoptObserverByOopt (id, date) {
    if (date === undefined) {
      date = null
    }
    return axios.get(`${i18n.locale}/api/animalAccounting/observePlot-ooptObserverListByOopt/${id}?date=${date}`)
  },
  // Список участков по текущему ООПТ
  listObservePlotByOopt (id, date) {
    return axios.get(`${i18n.locale}/api/animalAccounting/observePlotListByOopt/${id}?date=${date}`)
  },
  // Список наблюдателей по текущему ООПТ
  listOoptObserverByOopt (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/ooptObserverListByOopt/${id}`)
  },
  // Список ущелий по текущему участку
  listCanyonByObservePlot (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/canyonListByObservePlot/${id}`)
  },
  // Список
  list (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/animalAccounting/list?${filter}`)
  },
  // Получение данных для отображения карточки
  view (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/view/${id}`)
  },
  // Список действий
  getActions (statusId) {
    return axios.get(`${i18n.locale}/api/animalAccounting/actions/${statusId}`)
  },
  // Изменение статуса
  changeStatus (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/changeStatus/${id}`, data)
  },
  // Предсоздание карточки учета
  preCreate (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/pre-create/${id}`)
  },
  // Добавление фото к текущей сущности AnimalAccounting
  addPhotos (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/add-photos/${id}`, data)
  },
  // Удаление фото у текущей сущности AnimalAccounting
  deletePhoto (id, fileName) {
    return axios.get(`${i18n.locale}/api/animalAccounting/delete-photo/${id}/${fileName}`)
  },
  // Добавление наблюдателя к текущей сущности AnimalAccounting
  addObservers (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/add-ooptObservers/${id}`, data)
  },
  // Удаление наблюдателя у текущей сущности AnimalAccounting
  deleteObserver (animalAccountingId, ooptObserverId) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/delete-ooptObserver/${animalAccountingId}/${ooptObserverId}`)
  },
  // Создание сущности AnimalAccountingTrace
  createTrace (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/create-trace/${id}`)
  },
  // Создание сущности AnimalAccountingMeetingList
  createMeetingList (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/create-meetingList/${id}`)
  },
  // Обновление сущности AnimalAccountingTrace
  updateTrace (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/update-trace/${id}`, data)
  },
  // Обновление сущности AnimalAccountingMeetingList
  updateMeetingList (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/update-meetingList/${id}`, data)
  },
  // Удаление сущности AnimalAccountingTrace
  deleteTrace (id) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/delete-trace/${id}`)
  },
  // Удаление сущности AnimalAccountingMeetingList
  deleteMeetingList (id) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/delete-meetingList/${id}`)
  },
  // Получение данных для формы поиска
  getSearchFormData () {
    return axios.get(`${i18n.locale}/api/animalAccounting/searchFormData`)
  },
  // Загрузка gpx файла
  uploadGpx (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/uploadGpx/${id}`, data)
  },
  // Удаление gpx файла
  deleteGpx (id) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/deleteGpx/${id}`)
  },
  // Создание сущности AnimalAccountingStrength
  createStrength (id, fauna = null) {
    if (fauna) {
      return axios.get(`${i18n.locale}/api/animalAccounting/create-strength/${id}/${fauna}`)
    } else {
      return axios.get(`${i18n.locale}/api/animalAccounting/create-strength/${id}`)
    }
  },
  // Обновление сущности AnimalAccountingStrength
  updateStrength (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/update-strength/${id}`, data)
  },
  // Удаление сущности AnimalAccountingStrength
  deleteStrength (id) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/delete-strength/${id}`)
  },
  // печать в ворд
  wordPrint (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/word-print/${id}`, { responseType: 'arraybuffer' })
  },
  // Создание сущности AnimalAccountingMarmot
  createMarmot (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/create-marmot/${id}`)
  },
  // Обновление сущности AnimalAccountingMarmot
  updateMarmot (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/update-marmot/${id}`, data)
  },
  // Удаление сущности AnimalAccountingMarmot
  deleteMarmot (id) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/delete-marmot/${id}`)
  },
  // Обновление сущности AnimalAccounting
  updateFields (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/update-fields/${id}`, data)
  },
  // Создание сущности AnimalAccountingOndatra
  createOndatra (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/create-ondatra/${id}`)
  },
  // Обновление сущности AnimalAccountingOndatra
  updateOndatra (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/update-ondatra/${id}`, data)
  },
  // Удаление сущности AnimalAccountingOndatra
  deleteOndatra (id) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/delete-ondatra/${id}`)
  },
  // Удаление сущности AnimalAccounting
  deleteAnimalAccounting (id) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/delete/${id}`)
  },
  // Получение координат карточки
  coordinate (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/coordinate/${id}`)
  },
  // Список данных для страницы "Карта (карточки учета)"
  getAccountingFaunaCoordinatesData () {
    return axios.get(`${i18n.locale}/api/animalAccounting/getAccountingFaunaCoordinatesData`)
  },
  // Создание сущности AnimalAccountingNumberAnimal
  createNumberAnimal (id) {
    return axios.get(`${i18n.locale}/api/animalAccounting/create-numberAnimal/${id}`)
  },
  // Обновление сущности AnimalAccountingNumberAnimal
  updateNumberAnimal (id, data) {
    return axios.post(`${i18n.locale}/api/animalAccounting/update-numberAnimal/${id}`, data)
  },
  // Удаление сущности AnimalAccountingNumberAnimal
  deleteNumberAnimal (id) {
    return axios.delete(`${i18n.locale}/api/animalAccounting/delete-numberAnimal/${id}`)
  }
}
